// Галерея стилей СТО на вкладке «Главная»: только разрешённые стандартом виды абзацев, с живым образцом.
// Гарнитура и кегль не выбираются - их задаёт СТО (плашка «Times New Roman · 14 пт»).
import type { Ctx } from '../../core/registry';
import { registry } from '../../core/registry';
import { runCommand } from '../../core/ctx';
import { useEditorTick } from '../../ui/hooks';
import { prettyShortcut } from '../../ui/controls';

interface StyleTile { id: string; command: string; name: string; sample: string; cls: string }
const TILES: StyleTile[] = [
  { id: 'p', command: 'block.paragraph', name: 'Текст', sample: 'Абзац текста', cls: 'st-p' },
  { id: 'h1', command: 'block.h1', name: 'Раздел', sample: '1 Раздел', cls: 'st-h1' },
  { id: 'h2', command: 'block.h2', name: 'Подраздел', sample: '1.1 Подраздел', cls: 'st-h2' },
  { id: 'h3', command: 'block.h3', name: 'Пункт', sample: '1.1.1 Пункт', cls: 'st-h3' },
  { id: 'dash', command: 'list.dash', name: 'Перечисление', sample: '- пункт;', cls: 'st-list' },
  { id: 'letter', command: 'list.letter', name: 'Список а)', sample: 'а) пункт;', cls: 'st-list' },
  { id: 'digit', command: 'list.digit', name: 'Список 1)', sample: '1) подпункт;', cls: 'st-list' },
  { id: 'note', command: 'insert.note', name: 'Примечание', sample: 'Примечание –', cls: 'st-note' },
];

export function StylesGallery({ ctx }: { ctx: Ctx }) {
  useEditorTick();
  return (
    <div className="styles-gallery" role="listbox" aria-label="Стили СТО" data-testid="styles-gallery">
      {TILES.map((t) => {
        const cmd = registry.commands.get(t.command);
        if (!cmd) return null;
        const active = cmd.isActive ? cmd.isActive(ctx) : false;
        return (
          <button key={t.id} type="button" role="option" aria-selected={active} data-testid={'style-' + t.id}
            className={'style-tile ' + t.cls + (active ? ' is-active' : '')}
            data-tip={cmd.title} data-tip-desc={cmd.description} data-tip-key={cmd.shortcut ? prettyShortcut(cmd.shortcut) : undefined}
            onMouseDown={(e) => e.preventDefault()} onClick={() => runCommand(t.command)}>
            <span className="style-sample">{t.sample}</span>
            <span className="style-name">{t.name}</span>
          </button>
        );
      })}
    </div>
  );
}

export function FontInfo() {
  return (
    <div className="font-info" data-tip="Шрифт задаёт СТО" data-tip-desc="Times New Roman 14 пт, интервал 1,5, отступ 1,25 см; в таблицах и подписях 12 пт, в листингах Courier New 10 пт - всё ставит сборщик, менять не нужно">
      <span className="font-info-face">Times New Roman</span>
      <span className="font-info-size">14</span>
    </div>
  );
}
